<template>
  <div
    class="page-content-top"
    :style="rootBlockStyle"
  >
    <div
      class="page-content-top__block"
      :style="pageContentTopBlockStyle"
    >
      <div
        v-if="title || $slots.title"
        class="page-content-top__title"
      >
        <slot name="title">
          <h1 class="truncate">{{ title }}</h1>
        </slot>
      </div>

      <div class="flex-shrink-0">
        <slot name="page-content-top-right" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from '@/composition/vue/compositionApi'

const props = defineProps<{
  title?: string
  pageContentTopBlockStyle?: Pick<CSSStyleDeclaration, 'alignItems'>
  marginBottom?: string
}>()

const rootBlockStyle = computed(() => {
  if (!props.marginBottom) {
    return {}
  }
  return {
    marginBottom: props.marginBottom,
  }
})
</script>

<style lang="scss" scoped>
.page-content-top {
  width: 100%;
  flex: 0 auto;
  margin-bottom: var(--page-content-top-margin-bottom, 16px);

  &__block {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
  }

  &__title {
    flex-grow: 1;
    overflow: hidden;
  }
}
</style>
